import React, { createContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import API, { allCalAPI } from '../server'
import pusherSetup, { subscribeToUserChannel } from '../utils/pusherSetup'

const AppManager = ({ children }) => {
    const [isSideBarOpened, setIsSideBarOpened] = useState(true)
    const [isMobileDevice, setIsMobileDevice] = useState(false)
    const [loggedUser, setLoggedUser] = useState({})
    const [areHeadersSet, setAreHeadersSet] = useState(false)
    const [userChannel, setUserChannel] = useState({})

    const getAllcalUser = async (userId) => {
        const allcalUser = await allCalAPI.get('/accounts/' + userId + '/profile')
        return allcalUser.data
    }

    const getUserDataFromUrl = async () => {
        let url = window.location.href
        url = new URL(url)

        const urlUserData = {
            loginToken: url.searchParams.get('loginToken'),
            userId: url.searchParams.get('userId')
        }

        allCalAPI.setHeader('login-token', urlUserData.loginToken)
        API.setHeader('login-token', urlUserData.loginToken)
        setAreHeadersSet(true)

        const allcalUserData = await getAllcalUser(urlUserData.userId)

        return {
            ...allcalUserData,
            ...urlUserData
        }
    }

    const setAllcalUser = async () => {
        const userData = await getUserDataFromUrl()
        setLoggedUser({ ...userData })
    }

    const setupChatUpdatesChannel = async () => {
        pusherSetup(loggedUser.loginToken)
        setUserChannel(subscribeToUserChannel(loggedUser.userId))
    }

    useEffect(() => {
        setAllcalUser()

        setIsMobileDevice(window.orientation !== undefined)
        document.addEventListener('touchstart', {});
        window.addEventListener('touchstart', {});
    }, [])

    useEffect(() => {
        !_.isEmpty(loggedUser) && setupChatUpdatesChannel()
    }, [loggedUser])

    return <AppGlobalContext.Provider value={{
        isMobileDevice,
        loggedUser,
        isSideBarOpened,
        setIsSideBarOpened,
        areHeadersSet,
        userChannel
    }}
    >
        {children}
    </AppGlobalContext.Provider>
}

AppManager.propTypes = {
    children: PropTypes.object
}

// TODO: init context structure is optional, unless initial values are used
export const AppGlobalContext = createContext({
    isMobileDevice: false,
    loggedUser: {},
    isSideBarOpened: true,
    setIsSideBarOpened: () => { },
    areHeadersSet: false,
    userChannel: {}
})

export default AppManager
